import { CheckoutIntents } from 'checkout-intents';
import { baseURL } from 'config/constants';
import { env } from 'config/env';

class CheckoutIntentsClient {
  #client: CheckoutIntents | null = null;
  #apiKey: string | null = null;

  get() {
    return this.#client;
  }

  set(apiKey: string | null) {
    if (!apiKey) {
      this.#client = null;
      this.#apiKey = null;
      return null;
    }

    if (this.#apiKey === apiKey && this.#client) {
      return this.#client;
    }

    this.#apiKey = apiKey;
    this.#client = new CheckoutIntents({
      apiKey,
      baseURL: baseURL[env.VITE_NODE_ENV],
    });

    return this.#client;
  }

  reset() {
    this.#client = null;
    this.#apiKey = null;
  }
}

export const checkoutIntentsClient = new CheckoutIntentsClient();
